import { render, staticRenderFns } from "./TelFindPwd.vue?vue&type=template&id=f0c78f0a&scoped=true"
import script from "./TelFindPwd.vue?vue&type=script&lang=js"
export * from "./TelFindPwd.vue?vue&type=script&lang=js"
import style0 from "./TelFindPwd.vue?vue&type=style&index=0&id=f0c78f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c78f0a",
  null
  
)

export default component.exports